import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { homepageSettingsReducer } from './modules/HomepageSettings/reducer';
import { servicesReducer } from './modules/ServiceList/reducer';
import { serviceDetailReducer } from './modules/ServiceDetail/reducer';
import { newServiceReducer } from './modules/ServiceForm/reducer';
import { articlesReducer } from './modules/ArticleList/reducer';
import { newArticleReducer } from './modules/ArticleForm/reducer';
import { articleDetailReducer } from './modules/ArticleDetail/reducer';
import { informationsReducer } from './modules/InformationList/reducer';
import { newInformationReducer } from './modules/InformationForm/reducer';
import { informationDetailReducer } from './modules/InformationDetail/reducer';
import { pricingReducer } from './modules/Pricing/reducer';
import { aboutsReducer } from './modules/AboutList/reducer';
import { aboutDetailReducer } from './modules/AboutDetail/reducer';
import { newAboutReducer } from './modules/AboutForm/reducer';
import { referencesReducer } from './modules/ReferenceList/reducer';
import { newReferenceReducer } from './modules/ReferenceForm/reducer';
import { referenceDetailReducer } from './modules/ReferenceDetail/reducer';
import { employeeDetailReducer } from './modules/EmployeeDetail/reducer';
import { employeesReducer } from './modules/EmployeeList/reducer';
import { contactDetailReducer } from './modules/ContactDetail/reducer';
import { newContactReducer } from './modules/ContactForm/reducer';
import { contactsReducer } from './modules/ContactList/reducer';
import { pageDetailReducer } from './modules/PageDetail/reducer';
import { pagesReducer } from './modules/PageList/reducer';
import { newPageReducer } from './modules/PageForm/reducer';

export default combineReducers({
  form: formReducer,
  homepageSettings: homepageSettingsReducer,
  serviceList: servicesReducer,
  service: serviceDetailReducer,
  newService: newServiceReducer,
  articleList: articlesReducer,
  newArticle: newArticleReducer,
  article: articleDetailReducer,
  informationList: informationsReducer,
  newInformation: newInformationReducer,
  information: informationDetailReducer,
  pricing: pricingReducer,
  about: aboutDetailReducer,
  newAbout: newAboutReducer,
  aboutList: aboutsReducer,
  referenceList: referencesReducer,
  newReference: newReferenceReducer,
  reference: referenceDetailReducer,
  employee: employeeDetailReducer,
  employeeList: employeesReducer,
  contact: contactDetailReducer,
  newContact: newContactReducer,
  contactList: contactsReducer,
  page: pageDetailReducer,
  pageList: pagesReducer,
  newPage: newPageReducer
});



// WEBPACK FOOTER //
// ./src/reducers.js